import styled from 'styled-components';
import { Tooltip } from 'react-tippy';
import { Avatar as AvatarBase, space } from 'shared';

export const AvatarWrapper = styled.div`
  position: relative;

  .edit-icon-container {
    position: absolute;
    bottom: 100%;
    right: 12px;
    margin-bottom: -8px;
  }
  .avatar-input {
    display: none;
  }
`;

// Runder 134px-Profil-Container auf dem shared <Avatar size="lg">-Primitiv
// (borderRadiusRound-Token statt rohem 50 %). Das Primitiv liefert Groesse +
// Rundung + overflow:hidden + zentriertes & img (object-fit:cover). Konsumenten-
// spezifisch bleiben hier: margin-right, text-align, &.avatar-wrap (position:
// relative = Anker fuers Upload-Overlay) und die SVG-Innengroesse (65 %, kontext-
// spezifisch). Fallback (LetterAvatar/faUser) + Upload-Overlay bleiben lokal
// (Scope-Entscheid konservativ-minimal 2026-06-18). JSX unveraendert (children-Slot).
export const Avatar = styled(AvatarBase).attrs({ size: 'lg' })`
  margin-right: ${space(26)};
  text-align: center;
  &.avatar-wrap {
    margin-top: ${space(9)};
    color: ${({ theme }) => theme.white};
    position: relative;
  }
  & svg {
    width: 65% !important ;
    height: 65% !important ;
    display: block;
    object-fit: cover;
  }
`;

// F3 (Upload-Feedback 2026-06): Spinner-Overlay während des Avatar-Uploads.
// Vorher passierte beim Klick auf den Avatar sichtbar nichts, bis das neue Bild
// (irgendwann) erschien. Navy-transluzent (theme.secondary + 8-stelliges Hex-Alpha
// ~45 %) über dem runden Avatar, trägt den app-weiten <Spin>.
export const AvatarUploadingOverlay = styled.div`
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  border-radius: ${({ theme }) => theme.borderRadiusRound};
  background: ${({ theme }) => theme.secondary}73;
  z-index: 3;
  /* selbst zentrieren statt auf Spins Eigen-Layout zu vertrauen */
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const TooltipStyled = styled(Tooltip)`
  display: block !important;
  width: 100%;
  height: 100%;
`;
